import {PublishableVersionInfo} from 'template-collectibles/publishing-ui/TemplatePublishingTypes';
import {HasAvatar} from 'ui-library/avatar/Avatar';

export enum DocumentVersionEventAction {
  STRUCTURED_TABLE_SUBMIT = 'STRUCTURED_TABLE_SUBMIT',
}

export interface DocumentVersionEvent {
  id: number;
  apiIdentifier: string;
  action: DocumentVersionEventAction;
  createdAt: string;
  modifiedAt: string;
  actionMetadata: {
    [key: string]: unknown;
  };
}

export interface Version {
  id: number;
  // this is the name of document-like (entry, document, template, subtemplate etc.)
  // this is used to display the name of the document-like in the duplicated from link
  name?: string;
  // an apiIdentifier must exist for publishable (template, subtemplate etc.) versions
  // but does not exist for entry versions
  apiIdentifier?: string;
  modifiedAt: string;
  createdAt: string;
  creator: HasAvatar;
  // this field is only supplied for publishable versions when Publishing is enabled
  // (entry/document versions do not have publishingVersionInfo)
  publishableVersionInfo?: PublishableVersionInfo;

  // this field is supplied if the versions endpoint for the document-like returns events
  // currently only returned for entries and documents
  documentVersionEvent?: DocumentVersionEvent | null;

  // OAuth client attribution when a version was created by an app (e.g. Benchling AI)
  oauth2ClientId?: string;
  oauth2ClientName?: string;
}

export interface PublishingVersion extends Version {
  publishableVersionInfo: PublishableVersionInfo;
}
